export default (function stripTags(text) {
  // Remove ruby annotations (<rt>) entirely, keep ruby base text, then strip remaining format tags
  text = text.replace(/<rt\b[^>]*>[\s\S]*?<\/rt>/gi, "");
  return text.replace(/<\/?(p|span|em|strong|u|ruby|rt)\b[^>]*>/gi, '');
});